import Rails from './rails-ujs.js';
Rails.start();
import "@hotwired/turbo"
import $ from 'jquery'
window.$ = $
window.jQuery = $
import './cookie_notice.js';
import './popup_handler';
import './scroll_to_anchor';
import './fullcalendar.js'
import './de.js'
import './calendar'
import { BugController } from './bug.js';

document.addEventListener('turbo:load', () => {
  new BugController({});
});
